import { baseDateTimeFormats } from './formats/dateTimeBase';
import { baseNumberFormats } from './formats/numberBase';

export const dateTimeFormats = {
	en: baseDateTimeFormats,
	fr: baseDateTimeFormats,
};

export const numberFormats = {
	en: baseNumberFormats,
	fr: baseNumberFormats,
};
